import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex: 1 1 auto;
  flex-direction: row;
  max-height: 100%;
`;
